/* eslint-disable */

import TableScreen from "@/lib/components/table/TableScreen";

export default class Empresas extends TableScreen {

    constructor(store) {

        //Nome do model

        super('empresas', 'aqui_vai_o_endpoint_do_export');

        this.$store = store;

        //aqui os campos que serão exibidos no header do grid
        this.headerDx = [

            { caption: "Nome", dataField: "nome", dataType: "string" },
            { caption: "CNPJ", dataField: "cnpj", dataType: "string" },
        ];

        this.defaultItem = {};

        this.editedItem = {};

        //Título da tela

        this.title = 'Empresas';
        this.keyField = "id";
    }

}